<template>
  <v-flex xs12 sm6 md4 lg3 xl2 px-3 mb-2>
    <v-card color="cardBackground" class="bucket-lid rounded-3"></v-card>
        <v-card v-if="bucketGroup" color="cardBackground" class="px-4 py-2 mb-2 rounded-3 bucket-group-tile"  :to="{ path: bucketGroupRoute(caseTypeId, bucketGroup)}">
          <v-card-title class="pa-0 pb-2 pt-1">
              <v-flex xs12>
                      <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-3">{{bucketGroupName}}</h3>
                    </v-flex>
                  <v-flex xs12 pr-4 pt-0>
                      <h4 class="text-truncate">
                        <span
                          class="primary-text body-1 opacity-54"
                        >{{bucketCount}} Buckets</span>
                      </h4>
                    </v-flex>
                  </v-card-title>
                  <v-card-actions class="card-vert-menu">
                    <v-menu
                      nudge-top="30px"
                      left
                      offset-y
                      origin="center center"
                      transition="scale-transition">
                      <v-btn
                        flat icon dark
                        slot="activator" class="ma-0 mr-0 pa-0" color="secondary"
                        style="margin-top:calc(50% - 8px) !important; margin-left:-10px !important;"
                        @click.prevent>
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                      <v-list dense>
                        <v-list-tile v-if="!isBookmarked" @click="bookmarkGroup()">
                          <v-icon class="mr-2" color="secondary">bookmark</v-icon>
                          Bookmark this Bucket Group
                        </v-list-tile>
                        <v-list-tile v-if="isBookmarked" @click="removeBookmark()">
                          <v-icon class="mr-2" color="secondary">bookmark</v-icon>Remove bookmark
                        </v-list-tile>
                        <v-list-tile
                          :to="{ path: bucketGroupEditRoute(caseTypeId, bucketGroup)}">
                          <v-icon class="mr-2" color="secondary">edit</v-icon>
                          Edit Bucket Group
                        </v-list-tile>
                        <v-list-tile color="error" @click="showDeleteBucketGroupDialog = true">
                          <v-icon class="mr-2" color="error">delete</v-icon>
                          Delete Bucket Group
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
              <v-dialog v-model="showDeleteBucketGroupDialog" max-width="500">
                  <v-card class="pa-4">
                    <v-card-title class="pa-0 pb-2">
                      <h2>Are you sure you want to delete this bucket group?</h2>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <p>This will delete this bucket group and you won't be able to get it back.</p>
                    </v-card-text>
                    <v-card-actions class="ma-0 pa-0 pt-1">
                      <v-btn color="error" @click="deleteBucketGroup()">Yes, delete this bucket group</v-btn>
                      <v-btn @click="showDeleteBucketGroupDialog = false" color="secondary">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
        </v-card>
    </v-flex>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "BucketGroupTile",
  props: { bucketGroup: { type: Object } },
  data: () => ({
    bucketsToggled: false,
    showDeleteBucketGroupDialog: false
  }),
  computed: {
    ...mapState({
      caseTypeId: state => state.cbroute.params.case_type_id,
      bookmarks: state => state.ui.caseWorkMenu && state.ui.caseWorkMenu[0].items && state.ui.caseWorkMenu[0].items[0] && state.ui.caseWorkMenu[0].items[0].childItems && state.ui.caseWorkMenu[0].items[0].childItems ? state.ui.caseWorkMenu[0].items[0].childItems : []
    }),
    isBookmarked() {
      const bucketGroupRoute = this.bucketGroupRoute(this.caseTypeId, this.bucketGroup)
      const result = this.bookmarks.find((bookmark) => bookmark.route === bucketGroupRoute)
      return !!result
    },
    bucketGroupName() {
      return (this.bucketGroup && this.bucketGroup.name) || ""
    },
    bucketCount() {
      if (this.bucketGroup && this.bucketGroup.buckets) {
        return this.bucketGroup.buckets.length
      }
      return 0
    }
  },
  methods: {
    bucketGroupRoute: (caseTypeId, bucketGroup) => {
      const id = bucketGroup && bucketGroup.id != null ? bucketGroup.id : ""
      return `/case-types/${caseTypeId}/bucket-groups/${id}`
    },
    bucketGroupEditRoute: (caseTypeId, bucketGroup) => {
      const id = bucketGroup && bucketGroup.id != null ? bucketGroup.id : ""
      return `/case-types/${caseTypeId}/bucket-groups/${id}/edit`
    },
    async bookmarkGroup() {
      const route = this.bucketGroupRoute(this.caseTypeId, this.bucketGroup)
      await this.$store.dispatch("createBookmark", { route: route, linkText: this.bucketGroup.name })
    },
    async removeBookmark() {
      const bucketGroupRoute = this.bucketGroupRoute(this.caseTypeId, this.bucketGroup)
      const result = this.bookmarks.find((bookmark) => bookmark.route === bucketGroupRoute)
      if (result) {
        await this.$store.dispatch("deleteBookmark", { id: result.id })
      } else {
        this.$store.commit("displayFlashMessage", { message: "ID not found, cannot delete..", severity: "error" })
      }
    },
    async deleteBucketGroup() {
      this.showDeleteBucketGroupDialog = false
      await this.$store.dispatch("deleteBucketGroup", this.bucketGroup.id)
    }
  }
}
</script>
<style>
  .bucket-group-tile {
    position:relative;
  }

  .bucket-group-tile:before {
    width:auto;
    padding:3px 10px 3px 30px;
    position:absolute;
    background:rgb(29, 48, 62);
    right:0px;
    -webkit-border-bottom-right-radius: 3px;
    -webkit-border-top-left-radius: 3px;
    -moz-border-radius-bottomright: 3px;
    -moz-border-radius-topleft:3px;
    border-bottom-right-radius: 3px;
    border-top-left-radius: 3px;
    bottom:0px;
    content:'GROUP';
    font-size:0.7em;
    color:white;
  }

    .bucket-group-tile:after {
    width:auto;
    position:absolute;
    right:47px;
    bottom:0px;
    font-family: 'Material Icons';
    content: "subdirectory_arrow_left";
    font-size:0.9em;
    color:white;
    -moz-transform: rotate(270deg);
    -webkit-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
  }
</style>
